<template>
    <div class="content container">
        <div>
            <Home v-show="selected === 'home'" v-on:routeTo="routeTo"/>
            <AboutMe v-show="selected === 'am'" v-on:routeTo="routeTo"/>
            <FieldsOfRights v-show="selected === 'for'" v-on:routeTo="routeTo"/>
            <LawOfTenancy v-show="selected === 'lot'" v-on:routeTo="routeTo"/>
            <FamiliyLaw v-show="selected === 'fl'" v-on:routeTo="routeTo"/>
            <CriminalLaw v-show="selected === 'cl'" v-on:routeTo="routeTo"/>
            <LegalNotes v-show="selected === 'ln'" v-on:routeTo="routeTo"/>
            <PrivacyPolicy v-show="selected === 'pp'" v-on:routeTo="routeTo"/>
            <Contact v-show="selected === 'contact'" v-on:routeTo="routeTo"/>
        </div>
    </div>
</template>

<script>

    import Home from "../views/Home";
    import AboutMe from "../views/AboutMe";
    import CriminalLaw from "../views/CriminalLaw";
    import FamiliyLaw from "../views/FamilyLaw";
    import FieldsOfRights from "../views/FieldsOfRights";
    import LawOfTenancy from "../views/LawOfTenancy";
    import LegalNotes from "../views/LegalNotes";
    import PrivacyPolicy from "../views/PrivacyPolicy";
    import Contact from "../views/Contact";

    export default {
        name: "ContentRouter.vue",
        components: {
            Home,
            AboutMe,
            CriminalLaw,
            FamiliyLaw,
            FieldsOfRights,
            LawOfTenancy,
            LegalNotes,
            PrivacyPolicy,
            Contact
        },
        props: {
            selected: String
        },
        methods:{
            routeTo(page){
                this.$emit('routeTo', page)
            }
        }
    }
</script>

<style scoped>

</style>